export function drawerLine({
  _this,
  myChart,
  data,
  xAxis,
  unit,
  legend,
  max,
  min,
  splitNumber,
  yAxis
}) {
  /*   {
      name: this.tableData[i].series[ind].name,
      type: "line",
      
      symbolSize: 10,symbol: "circle",
      lineStyle: {
        normal: {
          width: 3,
        },
      },
      itemStyle: {
        normal: {
          color: this.$config.chartColors[ind],
        },
      },
      data: [],
    } */
  var maxValue = 0,
    minValue = 0,
    dataArr = [];
  for (let i1 in data) {
    for (let i2 in data[i1].data) {
      if (data[i1].data[i2] != '' && data[i1].data[i2] !== null) dataArr.push(+data[i1].data[i2])
    }
  }
  dataArr = dataArr.sort((a, b) => a - b)
  maxValue = Math.ceil((+dataArr[dataArr.length - 1] * 1.1))
  minValue = Math.floor((+dataArr[0] * 0.9))
  var option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        lineStyle: {
          color: '#57617B'
        }
      },
      position: 'top',
      confine: true,
      appendToBody: true,
      formatter: function (parms) {
        let str = parms[0].axisValue + "</br>"
        parms.map(v => {
          let displayValue = v.value;
          if (v.data && v.data.mark) {
            displayValue = `${v.value}(${v.data.mark})`;
          }
          str += `${v.marker} ${v.seriesName}：${_this.$str(displayValue)}</br>`;
        })
        return str;
      }
    },
    legend: {
      top: '20',
      right: '60',
      width: '90%',
      textStyle: {
        fontSize: 12,
        color: 'rgba(129, 134, 165, 1)',
      },
      itemWidth: 14,
      itemHeight: 10,
      // selectedMode: legend.selectedMode,
      selected: legend && legend.selected ? legend.selected : []
    },
    grid: {
      top: '50',
      right: '30',
      bottom: '20',
      left: '30',
      containLabel: true
    },
    xAxis: [{
      type: 'category',
      axisLine: {
        show: false,
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        textStyle: {
          fontSize: 12,
          color: 'rgba(129, 134, 165, 1)',
          padding: [6, 0, 0, 0]
        }
      },
      data: xAxis
    }],
    yAxis: yAxis || {
      nameTextStyle: {
        padding: [0, 0, 0, 0]
      },
      type: 'value',
      name: unit || '',
      // splitNumber: !isNaN(max) || !isNaN(min) ? null : splitNumber || 4,
      scale: false ,
      max: max || null,
      min: min || null,
      axisTick: {
        show: false
      },
      axisLine: {
        show: false,
        lineStyle: {
          fontSize: 12,
          color: 'rgba(129, 134, 165, 1)'
        }
      },
      axisLabel: {
        textStyle: {
          fontSize: 12,
          color: 'rgba(129, 134, 165, 1)'
        },
      },
      splitLine: {
        lineStyle: {
          color: '#E4E7ED',
          type: 'dashed',
        }
      }
    },
    series: data
  };
  if (legend && legend.selectedMode) {
    option.legend.selectedMode = legend.selectedMode
  }

  if (myChart) myChart.setOption(option)
}



// WEBPACK FOOTER //
// ./src/util/chartsLine.js